import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import ViewTabs from '../../../organisms/AdvisorView/components/AdvisorViewTabs/index'
import RolesWealthOwnerView from '../Roles/RolesWealthOwnerView'
import { useCheckPolicy } from '../../../../hooks'
import { ROLES } from '../../../../policies/admin'
import { usePermissionGroupsActive } from '../../../../hooks/featureChecks'
import ClientListTab from './ClientListTab'
import HeaderActions from './HeaderActions'
import UsersListTab from './UsersListTab'
import WealthOwnerPermissionGroupsTab from './PermissionGroupTab'

const tabOptions = {
  households: {
    label: 'Households',
    value: 'households'
  },
  users: {
    label: 'Users',
    value: 'users'
  },
  experiences: {
    label: 'Experiences',
    key: 'experiences'
  },
  permissionGroups: {
    label: 'Permission Groups',
    key: 'permissionGroups'
  }
}

const useStyles = makeStyles((theme) => ({
  container: {
    padding: '1rem'
  },
  roundedButton: {
    border: 'var(--border-primary-normal)',
    borderRadius: 'var(--border-radius-round)',
    padding: '0.45rem 1rem',
    textTransform: 'none',
    fontWeight: 'bold',
    fontSize: '0.875rem',
    alignSelf: 'flex-start',
    marginLeft: 'auto',
    '& .MuiButton-label': {
      fontSize: '0.75rem'
    }
  },
  actions: {
    marginLeft: 'auto',
    display: 'flex',
    gap: '0.5rem'
  }
}))

function ClientsView () {
  const classes = useStyles()
  const [modalOpen, setModalOpen] = React.useState(false)
  const canViewWealthOwnerRoles = useCheckPolicy(ROLES.viewWealthOwnerRoles)
  const hasWOPermissionGroupPermissions = useCheckPolicy('admin_edit_wo_permissions')
  const hasWOPermissionGroupFeatureFlag = usePermissionGroupsActive()
  const canEditPermissionGroups = hasWOPermissionGroupPermissions && hasWOPermissionGroupFeatureFlag
  const displayTabOptions = useMemo(() => {
    return Object.keys(tabOptions).reduce((acc, key) => {
      if (key === 'experiences' && !canViewWealthOwnerRoles) return acc
      if (key === 'permissionGroups' && !canEditPermissionGroups) return acc
      acc[key] = tabOptions[key]
      return acc
    }, {})
  }, [canViewWealthOwnerRoles, canEditPermissionGroups])
  return (
    <div className={classes.container}>
      <ViewTabs.Group tabOptions={displayTabOptions}>
        <ViewTabs.Links
          tabsKey='admin_clients_list'
          searchParamKey='tab'
          rightAdornment={<HeaderActions setModalOpen={setModalOpen} />}
        />
        <ViewTabs.Tab value='households'>
          <ClientListTab />
        </ViewTabs.Tab>
        <ViewTabs.Tab value='users'>
          <UsersListTab />
        </ViewTabs.Tab>
        <ViewTabs.Tab value='experiences'>
          <RolesWealthOwnerView />
        </ViewTabs.Tab>
        {canEditPermissionGroups && (
          <ViewTabs.Tab value='permissionGroups'>
            <WealthOwnerPermissionGroupsTab modalOpen={modalOpen} setModalOpen={setModalOpen} />
          </ViewTabs.Tab>
        )}
      </ViewTabs.Group>
    </div>
  )
}

ClientsView.propTypes = {
}

ClientsView.defaultProps = {
}

export default ClientsView
